export default "__VITE_ASSET__CvDG4U7S__"